export const USER_REQUEST = "USER_REQUEST"
export const USER_SUCCESS = "USER_SUCCESS"
export const USER_ERROR = "USER_ERROR"
export const USER_LOGOUT = "USER_LOGOUT"
export const USER_ADD_SESSION = "USER_ADD_SESSION"
export const USER_VIEW_SESSION = "USER_VIEW_SESSION"
export const USER_UPDATE_PROFILE = "USER_UPDATE_PROFILE"